import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
const items = ['Consultare i volumi clinici', 'Esplorare gli algoritmi decisionali', 'Aprire la libreria dei casi risolti', 'Utilizzare le risorse pratiche'];
export function Guarantee() {
  return <section className="bg-navy-50 py-14 sm:py-20" data-id="element-188" data-mp="1x41xsy7hrxzt">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-189" data-mp="1x2ikngh4u329">
        <div className="rounded-2xl border-2 border-gold-500/50 bg-white p-6 text-center sm:p-9" data-id="element-190" data-mp="19fitetrkc5d0">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-navy-900" data-id="element-191" data-mp="14gz2sg20y5eb">
            <ShieldCheckIcon className="h-8 w-8 text-gold-400" aria-hidden="true" data-id="element-192" data-mp="1j652e54rxxmq" />
          </span>

          <h2 className="mt-5 text-[24px] font-black uppercase leading-tight tracking-tight text-navy-900 sm:text-3xl" data-id="element-193" data-mp="1ec99hh3db0yf">
            La tua garanzia di 7 giorni
          </h2>
          <p className="mt-2 text-[13px] font-extrabold uppercase tracking-[0.14em] text-gold-700" data-id="element-194" data-mp="lo50alll85qz">
            Esploralo. Utilizzalo. Decidi tu.
          </p>

          <p className="mt-4 text-[15px] leading-relaxed text-navy-900/70" data-id="element-195" data-mp="tymiwb3d3t0a">
            Hai 7 giorni per esplorare il Sistema Maestro della TRT™. Puoi:
          </p>

          <ul className="mx-auto mt-5 grid max-w-md gap-2 text-left sm:grid-cols-2" data-id="element-196" data-mp="yq4jgy1h3rkq">
            {items.map(item => <li key={item} className="flex items-start gap-2 text-[14px] font-medium leading-snug text-navy-900" data-id="element-197" data-mp="12sr2qak2w46b">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-600" aria-hidden="true" data-id="element-198" data-mp="b0a86kwsyb2l" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 text-[13px] leading-relaxed text-navy-900/60" data-id="element-199" data-mp="jyc3cjtuu9hy">
            Se decidi che non è la risorsa giusta per le tue esigenze, contatta
            l’assistenza entro il periodo di 7 giorni previsto e richiedi il
            rimborso secondo la politica di rimborso.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-200" data-mp="3rktavovr496z">
            <CtaBlock label="Accedi ora per 19 EUR" note="Provalo con maggiore sicurezza" data-id="element-201" data-mp="3nhwr3uuh671g" />
          </div>
        </div>
      </div>
    </section>;
}